/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { IndicatorsContainerProps } from 'react-select';
import { GroupBase } from 'react-select';
import { components } from 'react-select';
import styles from './IndicatorsContainer.module.scss';
import { PlusSvgIcon } from './PlusSvgIcon.js';

export interface IndicatorsContainerCustomProps {
  onPlusClick: () => void;
}

export const IndicatorsContainer = <
  Option,
  IsMulti extends boolean = boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  children,
  ...props
}: IndicatorsContainerProps<Option, IsMulti, Group>) => {
  const { onPlusClick } = (
    props.selectProps as unknown as {
      customProps: IndicatorsContainerCustomProps;
    }
  ).customProps;

  const handleMouseDown = (e: React.SyntheticEvent) => {
    e.stopPropagation();
  };

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <components.IndicatorsContainer {...props}>
      {children}
      <div
        className={styles.plusButton}
        onClick={onPlusClick}
        onMouseDown={handleMouseDown}
      >
        <PlusSvgIcon />
      </div>
    </components.IndicatorsContainer>
  );
};
